<template>
  <div class="m-auto m-1230">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img src="@/assets/images/login.jpg" class="rounded-3" alt="login"/>
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto">
          <div class="d-inline-block mb-4">
            <img
                src="/images/viavox_group_logotyp.png"
                class="rounded-3 for-light-logo"
                alt="login"
            />
            <img
                src="/images/viavox_group_logotyp.png"
                class="rounded-3 for-dark-logo"
                alt="login"
            />
          </div>
          <h3 class="fs-28 mb-2">Авторизация</h3>
          <p class="fw-medium fs-16 mb-4">

          </p>

          <!-- Login Form -->
          <form @submit.prevent="handleLogin">
            <div class="form-group mb-4">
              <label class="label text-secondary">Логин</label>
              <input
                  type="text"
                  class="form-control h-55"
                  placeholder="Введите ваш логин"
                  v-model="username"
                  required
              />
            </div>
            <div class="form-group mb-4">
              <label class="label text-secondary">Пароль</label>
              <input
                  type="password"
                  class="form-control h-55"
                  placeholder="Введите ваш пароль"
                  v-model="password"
                  required
              />
            </div>


            <!-- Display Error Message -->
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>

            <!-- Login Button -->
            <div class="form-group mb-4">
              <button type="submit" class="btn btn-primary fw-medium py-2 px-3 w-100">
                <div class="d-flex align-items-center justify-content-center py-1">
                  <i class="material-symbols-outlined text-white fs-20 me-2"> login </i>
                  <span v-if="!loading">Войти</span>
                  <span v-else>Выполняется вход...</span>
                </div>
              </button>
            </div>


          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {useAuthStore} from "@/stores/auth";
import {useRoute, useRouter} from "vue-router";
import api from "@/api/axios"; // Import axios API instance

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const username = ref("");
const password = ref("");
const loading = ref(false);
const errorMessage = ref("");

const handleLogin = async () => {
  loading.value = true;
  errorMessage.value = "";

  try {
    // Ensure Sanctum CSRF protection is in place
    await api.get("/sanctum/csrf-cookie");

    // Send login request correctly
    const response = await api.post("/auth/login", {
      username: username.value,
      password: password.value,
    });

    // Ensure authStore correctly processes the response
    authStore.setUser(response.data.data); // Set user data in store

    // Save the token in localStorage
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("user", JSON.stringify(response.data.data));

    // After login, set the token for further API requests
    api.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;

    //console.log('User and Token:', response.data.data, response.data.token);
    console.log('user_id', response.data.data.id)


    // Redirect after successful login
    if (route.fullPath.includes('legal')) {
      window.location.href = '/legal/index';
    } else {
      if (response.data.data.id === 1) {
        window.location.href = "/tasks/manage";
      } else {
        window.location.href = "/tasks/index";
      }
    }

  } catch (error: any) {
    console.log(error);
    if (error.response && error.response.data) {
      errorMessage.value = error.response.data.message || "Ошибка входа";
    } else {
      errorMessage.value = "An unexpected error occurred.";
    }
  } finally {
    loading.value = false;
  }
};
</script>
